module.exports = __webpack_public_path__ + "03_very_short_gold.36f4796e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer5/03_very_short_gold.png
// module id = lXst
// module chunks = 0